const getPluginId = () => {
  const queryParams = new URLSearchParams(window.location.search);
  const queryParamPluginId = queryParams.get('plugin');

  const entryPluginId = document?.getElementById(process.env.REACT_APP_ROOT_ID)?.getAttribute('data-plugin') || queryParamPluginId;

  return entryPluginId;
};

export default getPluginId;
